import {useStyles} from '@wix/tpa-settings/react'
import {ExperimentNames, LIST_LAYOUT, MOBILE_WIDGET_LAYOUT} from '@wix/wix-events-commons-statics'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {useSettings} from '../../../../hooks/use-settings'
import settingsParams from '../../../../settingsParams'
import stylesParams from '../../../../stylesParams'
import {useWidgetState} from '../../../hooks/state-provider'
import sc from '../../classes.scss'
import {Spinner} from '../../spinner'
import {TodayButtonProps} from './interfaces'
import s from './today-button.scss'

export const TodayButton = ({dataHook, loading, onClick}: TodayButtonProps) => {
  const {t} = useTranslation()
  const {get: getSetting} = useSettings()
  const {experiments} = useExperiments()
  const {get} = useStyles()

  const todayButtonText = getSetting(settingsParams.todayButtonText)
  const mobile = useWidgetState(isMobile)
  const calendar = mobile
    ? get(stylesParams.mobileWidgetLayoutNew) === MOBILE_WIDGET_LAYOUT.CALENDAR
    : get(stylesParams.listLayout) === LIST_LAYOUT.CALENDAR

  return (
    <div className={classNames(s.container, {[s.mobile]: mobile})}>
      {loading ? <Spinner className={s.loader} diameter={20} calendarButton /> : null}
      <button
        data-hook={dataHook}
        onClick={() => onClick()}
        type="button"
        className={classNames(s.button, sc.ellipsis, {
          [s.mobileList]: mobile && !calendar,
          [s.loading]: loading,
          [s.rewire]: experiments.enabled(ExperimentNames.MobileCalendarRewire),
          [s.hoverColor]: !mobile && experiments.enabled(ExperimentNames.CalendarRevamp),
        })}
      >
        {todayButtonText || t('layout.calendar.monthly.controls.today')}
      </button>
    </div>
  )
}
